function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import { FileChecksum } from "./file_checksum";
import { BlobRecord } from "./blob_record";
import { BlobUpload } from "./blob_upload";
var id = 0;
export var DirectUpload = /*#__PURE__*/function () {
  function DirectUpload(file, url, delegate) {
    _classCallCheck(this, DirectUpload);

    this.id = ++id;
    this.file = file;
    this.url = url;
    this.delegate = delegate;
  }

  _createClass(DirectUpload, [{
    key: "create",
    value: function create(callback) {
      var _this = this;

      FileChecksum.create(this.file, function (error, checksum) {
        if (error) {
          callback(error);
          return;
        }

        var blob = new BlobRecord(_this.file, checksum, _this.url);
        notify(_this.delegate, "directUploadWillCreateBlobWithXHR", blob.xhr);
        blob.create(function (error) {
          if (error) {
            callback(error);
          } else {
            var upload = new BlobUpload(blob);
            notify(_this.delegate, "directUploadWillStoreFileWithXHR", upload.xhr);
            upload.create(function (error) {
              if (error) {
                callback(error);
              } else {
                callback(null, blob.toJSON());
              }
            });
          }
        });
      });
    }
  }]);

  return DirectUpload;
}();

function notify(object, methodName) {
  if (object && typeof object[methodName] == "function") {
    for (var _len = arguments.length, messages = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
      messages[_key - 2] = arguments[_key];
    }

    return object[methodName].apply(object, messages);
  }
}